module.exports = __webpack_public_path__ + "img/logo.fbbaf769.svg";